import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { ISO_DATE_FORMAT_WITH_FULL_TIME } from "utils/constants/format.constants";

dayjs.extend(utc);

type TDatePossibleType = Dayjs | number | string | null;

export const isDateValid = (date: TDatePossibleType) => {
  return dayjs(date).isValid();
};

export const isDateInFuture = (date: TDatePossibleType) => {
  // When the value of date is created in the date picker, it uses the correct date numbers, but
  // interprets it as in the local time. Since we are displaying the date picker as if those dates
  // are in UTC, we have to take that date that it thinks its giving back on selection and
  // reinterpret it back into the UTC that we intended it to be. Then we can get the current date in
  // UTC and compare them, ensuring that the comparison is entirely with UTC dates.
  const dateInUTC = dayjs.utc(
    dayjs(date).format(ISO_DATE_FORMAT_WITH_FULL_TIME),
  );

  return dayjs.utc().isSame(dateInUTC, "day") || dateInUTC.isAfter(dayjs.utc());
};

export const isSameDateTime = (
  dateA: TDatePossibleType,
  dateB: TDatePossibleType,
) => {
  return dayjs(dateA).isSame(dateB);
};
